import React, { useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import { AuthContext } from "../../context/Auth/AuthContext";
import { useThemeContext } from "../../context/DarkMode";
import NotificationsPopOver from "../NotificationsPopOver";
import UserModal from "../UserModal";
import { Menu, MenuItem, Divider } from "@material-ui/core";
import "./GxonTemplate.css";

const GxonLayout = ({ children }) => {
    const history = useHistory();
    const { user, handleLogout } = useContext(AuthContext);
    const { toggleTheme, darkMode } = useThemeContext();
    console.log(" Dzapy Layout Engine: v11.34 Chat Evolution Active");
    const [openUserModal, setOpenUserModal] = useState(false);
    const [notificationsPopoverOpen, setNotificationsPopoverOpen] = useState(false);
    const [notificationsAnchor, setNotificationsAnchor] = useState(null);
    const [profileAnchor, setProfileAnchor] = useState(null);
    const [profileDropdownOpen, setProfileDropdownOpen] = useState(false);
    // Start with sidebar collapsed (mini) on mobile
    const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
    const [sidebarHovered, setSidebarHovered] = useState(false);

    React.useEffect(() => {
        const html = document.documentElement;
        if (sidebarCollapsed && !sidebarHovered) {
            html.setAttribute('data-app-sidebar', 'mini');
        } else {
            html.setAttribute('data-app-sidebar', 'full');
        }
    }, [sidebarCollapsed, sidebarHovered]);

    // Menu accordion state
    const [openMenus, setOpenMenus] = useState({
        dashboard: true,
        atendimento: false,
        automacao: false,
        administracao: false,
        kanban: false,
        agendamento: false,
        marketing: false,
        integracoes: false
    });

    const handleMenuClick = (menuName) => {
        setOpenMenus(prev => ({
            ...Object.keys(prev).reduce((acc, key) => ({ ...acc, [key]: false }), {}),
            [menuName]: !prev[menuName]
        }));
    };

    const handleNotificationsOpen = (event) => {
        setNotificationsAnchor(event.currentTarget);
        setNotificationsPopoverOpen(true);
    };

    const handleNotificationsClose = () => {
        setNotificationsAnchor(null);
        setNotificationsPopoverOpen(false);
    };

    const handleProfileOpen = (event) => {
        event.preventDefault();
        setProfileDropdownOpen(!profileDropdownOpen);
    };

    const handleProfileClose = () => {
        setProfileDropdownOpen(false);
    };

    const isExpanded = !sidebarCollapsed || sidebarHovered;

    return (
        <React.Fragment>
            <div className={`gxon-wrapper ${sidebarCollapsed ? 'sidebar-collapsed' : ''} ${sidebarHovered ? 'sidebar-hovered' : ''}`}>
                <div className="page-layout">
                    {/* Header */}
                    <header className="app-header">
                        <div className="app-header-inner">
                            <button
                                className={`app-toggler ${sidebarCollapsed ? 'active' : ''}`}
                                type="button"
                                aria-label="app toggler"
                                onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
                                style={{ zIndex: 10001 }}
                            >
                                <i className={sidebarCollapsed ? "fi fi-rr-cross" : "fi fi-rr-menu-burger"}></i>
                            </button>
                            <div className="app-header-start d-none d-md-flex">
                                <form className="d-flex align-items-center h-100 w-lg-250px w-xxl-300px position-relative" action="#" onSubmit={(e) => e.preventDefault()}>
                                    <button type="button" className="btn btn-sm border-0 position-absolute start-0 ms-3 p-0">
                                        <i className="fi fi-rr-search"></i>
                                    </button>
                                    <input type="text" className="form-control rounded-5 ps-5" placeholder="Buscar..." />
                                </form>
                            </div>
                            <div className="app-header-end">
                                <div className="px-lg-3 px-2 ps-0 d-flex align-items-center">
                                    <div className="dropdown">
                                        <button
                                            className="btn btn-icon btn-action-gray rounded-circle waves-effect waves-light position-relative"
                                            id="ld-theme"
                                            type="button"
                                            onClick={toggleTheme}
                                        >
                                            <i className={`fi ${darkMode ? "fi-rr-moon-stars" : "fi-rr-brightness"} scale-1x theme-icon-active`}></i>
                                        </button>
                                    </div>
                                </div>
                                <div className="vr my-3"></div>
                                <div className="d-flex align-items-center gap-sm-2 gap-0 px-lg-4 px-sm-2 px-1">
                                    <a href="#" className="btn btn-icon btn-action-gray rounded-circle waves-effect waves-light position-relative">
                                        <i className="fi fi-rr-envelope"></i>
                                    </a>
                                    <div className="dropdown text-end">
                                        <button
                                            type="button"
                                            className="btn btn-icon btn-action-gray rounded-circle waves-effect waves-light"
                                            onClick={handleNotificationsOpen}
                                        >
                                            <i className="fi fi-rr-bell"></i>
                                        </button>
                                    </div>
                                    <a href="#" className="btn btn-icon btn-action-gray rounded-circle waves-effect waves-light">
                                        <i className="fi fi-rr-calendar"></i>
                                    </a>
                                </div>
                                <div className="vr my-3"></div>
                                <div className="dropdown text-end ms-sm-3 ms-2 ms-lg-4">
                                    <a
                                        href="#"
                                        className={`d-flex align-items-center py-2 ${profileDropdownOpen ? 'show' : ''}`}
                                        onClick={handleProfileOpen}
                                        aria-expanded={profileDropdownOpen}
                                    >
                                        <div className="text-end me-2 d-none d-lg-inline-block">
                                            <div className="fw-bold text-dark">{user?.name || "Usuário"}</div>
                                            <small className="text-body d-block lh-sm">
                                                <i className="fi fi-rr-angle-down text-3xs me-1"></i> {user?.profile || "Administrador"}
                                            </small>
                                        </div>
                                        <div className="avatar avatar-sm rounded-circle bg-primary text-white d-flex align-items-center justify-content-center">
                                            {user?.name?.charAt(0).toUpperCase() || "U"}
                                        </div>
                                    </a>
                                    <ul className={`dropdown-menu dropdown-menu-end w-225px mt-1 ${profileDropdownOpen ? 'show' : ''}`} style={{
                                        position: 'absolute',
                                        inset: '0px 0px auto auto',
                                        margin: '0px',
                                        transform: 'translate3d(0px, 58px, 0px)',
                                        display: profileDropdownOpen ? 'block' : 'none',
                                        zIndex: 100001
                                    }}>
                                        <li className="d-flex align-items-center p-2">
                                            <div className="avatar avatar-sm rounded-circle bg-primary text-white d-flex align-items-center justify-content-center">
                                                {user?.name?.charAt(0).toUpperCase() || "U"}
                                            </div>
                                            <div className="ms-2">
                                                <div className="fw-bold text-dark">{user?.name || "Usuário"}</div>
                                                <small className="text-body d-block lh-sm">{user?.email || ""}</small>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="dropdown-divider my-1"></div>
                                        </li>
                                        <li>
                                            <a className="dropdown-item d-flex align-items-center gap-2" href="javascript:void(0);" onClick={(e) => {
                                                e.preventDefault();
                                                setOpenUserModal(true);
                                                handleProfileClose();
                                            }}>
                                                <i className="fi fi-rr-user scale-1x"></i> Meu Perfil
                                            </a>
                                        </li>
                                        <li>
                                            <div className="dropdown-divider my-1"></div>
                                        </li>
                                        <li>
                                            <a className="dropdown-item d-flex align-items-center gap-2 text-danger" href="#" onClick={(e) => {
                                                e.preventDefault();
                                                handleLogout();
                                                handleProfileClose();
                                            }}>
                                                <i className="fi fi-sr-exit scale-1x"></i> Sair
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </header>

                    {/* Sidebar */}
                    <aside
                        className={`app-menubar ${isExpanded ? 'open' : 'mini'}`}
                        onMouseEnter={() => sidebarCollapsed && setSidebarHovered(true)}
                        onMouseLeave={() => setSidebarHovered(false)}
                    >
                        <div className="app-navbar-brand">
                            <a className="navbar-brand-logo" href="/">
                                <img src="https://dzapy.com.br/wp-content/uploads/2025/04/logoBr.png" alt="Dzapy" style={{ maxWidth: '140px' }} />
                            </a>
                            <a className="navbar-brand-mini" href="/">
                                <img src="/mini-logo.png" alt="Dzapy" style={{ width: '45px', height: 'auto' }} />
                            </a>
                        </div>
                        <nav className="app-navbar" data-simplebar>
                            <ul className="menubar">
                                {/* Dashboard */}
                                <li className="menu-item">
                                    <a
                                        className={`menu-link ${history.location.pathname === '/' ? 'active' : ''}`}
                                        href="/"
                                        onClick={(e) => { e.preventDefault(); history.push("/"); }}
                                    >
                                        <i className="fi fi-rr-apps"></i>
                                        <span className="menu-label">Dashboard</span>
                                    </a>
                                </li>

                                {/* Atendimento */}
                                <li className={`menu-item menu-arrow ${openMenus.atendimento || history.location.pathname.startsWith('/tickets') || history.location.pathname.startsWith('/contacts') || history.location.pathname.startsWith('/quickAnswers') || history.location.pathname.startsWith('/tags') || history.location.pathname.startsWith('/orders') || history.location.pathname.startsWith('/contact-schedules') || history.location.pathname.startsWith('/emails') ? 'show' : ''}`}>
                                    <a className={`menu-link ${history.location.pathname.startsWith('/tickets') || history.location.pathname.startsWith('/contacts') || history.location.pathname.startsWith('/quickAnswers') || history.location.pathname.startsWith('/tags') || history.location.pathname.startsWith('/orders') || history.location.pathname.startsWith('/contact-schedules') || history.location.pathname.startsWith('/emails') ? 'active' : ''}`} href="javascript:void(0);" onClick={() => handleMenuClick('atendimento')}>
                                        <i className="fi fi-rr-comment-alt"></i>
                                        <span className="menu-label">Atendimento</span>
                                    </a>
                                    <ul className="menu-inner" style={{ display: (openMenus.atendimento || history.location.pathname.startsWith('/tickets') || history.location.pathname.startsWith('/contacts') || history.location.pathname.startsWith('/quickAnswers') || history.location.pathname.startsWith('/tags') || history.location.pathname.startsWith('/orders') || history.location.pathname.startsWith('/contact-schedules') || history.location.pathname.startsWith('/emails')) ? 'block' : 'none' }}>
                                        <li className="menu-item">
                                            <a
                                                className={`menu-link ${history.location.pathname.startsWith('/tickets') ? 'active' : ''}`}
                                                href="/tickets"
                                                onClick={(e) => { e.preventDefault(); history.push("/tickets"); }}
                                            >
                                                <span className="menu-label">Conversas</span>
                                            </a>
                                        </li>
                                        <li className="menu-item">
                                            <a className={`menu-link ${history.location.pathname.startsWith('/contacts') ? 'active' : ''}`} href="/contacts" onClick={(e) => { e.preventDefault(); history.push("/contacts"); }}>
                                                <span className="menu-label">Contatos</span>
                                            </a>
                                        </li>
                                        <li className="menu-item">
                                            <a className={`menu-link ${history.location.pathname.startsWith('/orders') ? 'active' : ''}`} href="/orders" onClick={(e) => { e.preventDefault(); history.push("/orders"); }}>
                                                <span className="menu-label">Pedidos</span>
                                            </a>
                                        </li>
                                        <li className="menu-item">
                                            <a className={`menu-link ${history.location.pathname.startsWith('/quickAnswers') ? 'active' : ''}`} href="/quickAnswers" onClick={(e) => { e.preventDefault(); history.push("/quickAnswers"); }}>
                                                <span className="menu-label">Respostas Rápidas</span>
                                            </a>
                                        </li>
                                        <li className="menu-item">
                                            <a className={`menu-link ${history.location.pathname.startsWith('/tags') ? 'active' : ''}`} href="/tags" onClick={(e) => { e.preventDefault(); history.push("/tags"); }}>
                                                <span className="menu-label">Tags</span>
                                            </a>
                                        </li>
                                        <li className="menu-item">
                                            <a className={`menu-link ${history.location.pathname.startsWith('/contact-schedules') ? 'active' : ''}`} href="/contact-schedules" onClick={(e) => { e.preventDefault(); history.push("/contact-schedules"); }}>
                                                <span className="menu-label">Agendamentos</span>
                                            </a>
                                        </li>
                                        <li className="menu-item">
                                            <a className={`menu-link ${history.location.pathname.startsWith('/emails') ? 'active' : ''}`} href="/emails" onClick={(e) => { e.preventDefault(); history.push("/emails"); }}>
                                                <span className="menu-label">E-mails</span>
                                            </a>
                                        </li>
                                    </ul>
                                </li>

                                {/* Automação */}
                                <li className={`menu-item menu-arrow ${openMenus.automacao || history.location.pathname.startsWith('/chatbot') ? 'show' : ''}`}>
                                    <a className={`menu-link ${history.location.pathname.startsWith('/chatbot') ? 'active' : ''}`} href="javascript:void(0);" onClick={() => handleMenuClick('automacao')}>
                                        <i className="fi fi-rr-settings-sliders"></i>
                                        <span className="menu-label">Automação</span>
                                    </a>
                                    <ul className="menu-inner" style={{ display: (openMenus.automacao || history.location.pathname.startsWith('/chatbot')) ? 'block' : 'none' }}>
                                        <li className="menu-item">
                                            <a className={`menu-link ${history.location.pathname === '/chatbot' ? 'active' : ''}`} href="/chatbot" onClick={(e) => { e.preventDefault(); history.push("/chatbot"); }}>
                                                <span className="menu-label">Chatbot</span>
                                            </a>
                                        </li>
                                    </ul>
                                </li>

                                {/* Administração */}
                                <li className={`menu-item menu-arrow ${openMenus.administracao || ['/users', '/connections', '/queues', '/schedules', '/whatsapp-qrcode', '/settings', '/smtp-configs'].some(p => history.location.pathname.startsWith(p)) ? 'show' : ''}`}>
                                    <a className={`menu-link ${['/users', '/connections', '/queues', '/schedules', '/whatsapp-qrcode', '/settings', '/smtp-configs'].some(p => history.location.pathname.startsWith(p)) ? 'active' : ''}`} href="javascript:void(0);" onClick={() => handleMenuClick('administracao')}>
                                        <i className="fi fi-rr-settings"></i>
                                        <span className="menu-label">Administração</span>
                                    </a>
                                    <ul className="menu-inner" style={{ display: (openMenus.administracao || ['/users', '/connections', '/queues', '/schedules', '/whatsapp-qrcode', '/settings', '/smtp-configs'].some(p => history.location.pathname.startsWith(p))) ? 'block' : 'none' }}>
                                        <li className="menu-item">
                                            <a className={`menu-link ${history.location.pathname === '/users' ? 'active' : ''}`} href="/users" onClick={(e) => { e.preventDefault(); history.push("/users"); }}>
                                                <span className="menu-label">Usuários</span>
                                            </a>
                                        </li>
                                        <li className="menu-item">
                                            <a className={`menu-link ${history.location.pathname === '/connections' ? 'active' : ''}`} href="/connections" onClick={(e) => { e.preventDefault(); history.push("/connections"); }}>
                                                <span className="menu-label">Conexões</span>
                                            </a>
                                        </li>
                                        <li className="menu-item">
                                            <a className={`menu-link ${history.location.pathname === '/queues' ? 'active' : ''}`} href="/queues" onClick={(e) => { e.preventDefault(); history.push("/queues"); }}>
                                                <span className="menu-label">Filas</span>
                                            </a>
                                        </li>
                                        <li className="menu-item">
                                            <a className={`menu-link ${history.location.pathname === '/schedules' ? 'active' : ''}`} href="/schedules" onClick={(e) => { e.preventDefault(); history.push("/schedules"); }}>
                                                <span className="menu-label">Escalas</span>
                                            </a>
                                        </li>
                                        <li className="menu-item">
                                            <a className={`menu-link ${history.location.pathname === '/whatsapp-qrcode' ? 'active' : ''}`} href="/whatsapp-qrcode" onClick={(e) => { e.preventDefault(); history.push("/whatsapp-qrcode"); }}>
                                                <span className="menu-label">QRCode WhatsApp</span>
                                            </a>
                                        </li>
                                        <li className="menu-item">
                                            <a className={`menu-link ${history.location.pathname === '/settings' ? 'active' : ''}`} href="/settings" onClick={(e) => { e.preventDefault(); history.push("/settings"); }}>
                                                <span className="menu-label">Configurações</span>
                                            </a>
                                        </li>
                                        <li className="menu-item">
                                            <a className={`menu-link ${history.location.pathname === '/smtp-configs' ? 'active' : ''}`} href="/smtp-configs" onClick={(e) => { e.preventDefault(); history.push("/smtp-configs"); }}>
                                                <span className="menu-label">Configurar SMTP</span>
                                            </a>
                                        </li>
                                    </ul>
                                </li>

                                {/* Kanban */}
                                <li className={`menu-item menu-arrow ${openMenus.kanban || ['/kanban', '/products'].some(p => history.location.pathname.startsWith(p)) ? 'show' : ''}`}>
                                    <a className={`menu-link ${['/kanban', '/products'].some(p => history.location.pathname.startsWith(p)) ? 'active' : ''}`} href="javascript:void(0);" onClick={() => handleMenuClick('kanban')}>
                                        <i className="fi fi-rr-apps-sort"></i>
                                        <span className="menu-label">Kanban</span>
                                    </a>
                                    <ul className="menu-inner" style={{ display: (openMenus.kanban || ['/kanban', '/products'].some(p => history.location.pathname.startsWith(p))) ? 'block' : 'none' }}>
                                        <li className="menu-item">
                                            <a className={`menu-link ${history.location.pathname === '/kanban' ? 'active' : ''}`} href="/kanban" onClick={(e) => { e.preventDefault(); history.push("/kanban"); }}>
                                                <span className="menu-label">Funis</span>
                                            </a>
                                        </li>
                                        <li className="menu-item">
                                            <a className={`menu-link ${history.location.pathname === '/kanban/board' ? 'active' : ''}`} href="/kanban/board" onClick={(e) => { e.preventDefault(); history.push("/kanban/board"); }}>
                                                <span className="menu-label">Quadro</span>
                                            </a>
                                        </li>
                                        <li className="menu-item">
                                            <a className={`menu-link ${history.location.pathname === '/kanban/reports' ? 'active' : ''}`} href="/kanban/reports" onClick={(e) => { e.preventDefault(); history.push("/kanban/reports"); }}>
                                                <span className="menu-label">Relatórios</span>
                                            </a>
                                        </li>
                                        <li className="menu-item">
                                            <a className={`menu-link ${history.location.pathname === '/products' ? 'active' : ''}`} href="/products" onClick={(e) => { e.preventDefault(); history.push("/products"); }}>
                                                <span className="menu-label">Produtos</span>
                                            </a>
                                        </li>
                                    </ul>
                                </li>

                                {/* Agendamento */}
                                <li className={`menu-item menu-arrow ${openMenus.agendamento || ['/specialties', '/subspecialties', '/professionals', '/holidays', '/appointments'].some(p => history.location.pathname.startsWith(p)) ? 'show' : ''}`}>
                                    <a className={`menu-link ${['/specialties', '/subspecialties', '/professionals', '/holidays', '/appointments'].some(p => history.location.pathname.startsWith(p)) ? 'active' : ''}`} href="javascript:void(0);" onClick={() => handleMenuClick('agendamento')}>
                                        <i className="fi fi-rr-calendar"></i>
                                        <span className="menu-label">Agendamento</span>
                                    </a>
                                    <ul className="menu-inner" style={{ display: (openMenus.agendamento || ['/specialties', '/subspecialties', '/professionals', '/holidays', '/appointments'].some(p => history.location.pathname.startsWith(p))) ? 'block' : 'none' }}>
                                        <li className="menu-item">
                                            <a className={`menu-link ${history.location.pathname === '/specialties' ? 'active' : ''}`} href="/specialties" onClick={(e) => { e.preventDefault(); history.push("/specialties"); }}>
                                                <span className="menu-label">Especialidade</span>
                                            </a>
                                        </li>
                                        <li className="menu-item">
                                            <a className={`menu-link ${history.location.pathname === '/subspecialties' ? 'active' : ''}`} href="/subspecialties" onClick={(e) => { e.preventDefault(); history.push("/subspecialties"); }}>
                                                <span className="menu-label">Serviço</span>
                                            </a>
                                        </li>
                                        <li className="menu-item">
                                            <a className={`menu-link ${history.location.pathname === '/professionals' ? 'active' : ''}`} href="/professionals" onClick={(e) => { e.preventDefault(); history.push("/professionals"); }}>
                                                <span className="menu-label">Profissionais</span>
                                            </a>
                                        </li>
                                        <li className="menu-item">
                                            <a className={`menu-link ${history.location.pathname === '/holidays' ? 'active' : ''}`} href="/holidays" onClick={(e) => { e.preventDefault(); history.push("/holidays"); }}>
                                                <span className="menu-label">Feriados</span>
                                            </a>
                                        </li>
                                        <li className="menu-item">
                                            <a className={`menu-link ${history.location.pathname === '/appointments' ? 'active' : ''}`} href="/appointments" onClick={(e) => { e.preventDefault(); history.push("/appointments"); }}>
                                                <span className="menu-label">Agenda</span>
                                            </a>
                                        </li>
                                    </ul>
                                </li>

                                {/* Marketing */}
                                <li className={`menu-item menu-arrow ${openMenus.marketing || ['/campaigns', '/campaign-landing-pages', '/campaign-leads', '/whatsapp-status', '/marketing-dashboard', '/email-templates', '/email-campaigns'].some(p => history.location.pathname.startsWith(p)) ? 'show' : ''}`}>
                                    <a className={`menu-link ${['/campaigns', '/campaign-landing-pages', '/campaign-leads', '/whatsapp-status', '/marketing-dashboard', '/email-templates', '/email-campaigns'].some(p => history.location.pathname.startsWith(p)) ? 'active' : ''}`} href="javascript:void(0);" onClick={() => handleMenuClick('marketing')}>
                                        <i className="fi fi-rr-megaphone"></i>
                                        <span className="menu-label">Marketing</span>
                                    </a>
                                    <ul className="menu-inner" style={{ display: (openMenus.marketing || ['/campaigns', '/campaign-landing-pages', '/campaign-leads', '/whatsapp-status', '/marketing-dashboard', '/email-templates', '/email-campaigns'].some(p => history.location.pathname.startsWith(p))) ? 'block' : 'none' }}>
                                        <li className="menu-item">
                                            <a className={`menu-link ${history.location.pathname === '/marketing-dashboard' ? 'active' : ''}`} href="/marketing-dashboard" onClick={(e) => { e.preventDefault(); history.push("/marketing-dashboard"); }}>
                                                <span className="menu-label">Dashboard</span>
                                            </a>
                                        </li>
                                        <li className="menu-item">
                                            <a className={`menu-link ${history.location.pathname === '/campaigns' ? 'active' : ''}`} href="/campaigns" onClick={(e) => { e.preventDefault(); history.push("/campaigns"); }}>
                                                <span className="menu-label">CP WhatsApp</span>
                                            </a>
                                        </li>
                                        <li className="menu-item">
                                            <a className={`menu-link ${history.location.pathname === '/email-campaigns' ? 'active' : ''}`} href="/email-campaigns" onClick={(e) => { e.preventDefault(); history.push("/email-campaigns"); }}>
                                                <span className="menu-label">CP de E-mail</span>
                                            </a>
                                        </li>
                                        <li className="menu-item">
                                            <a className={`menu-link ${history.location.pathname === '/email-templates' ? 'active' : ''}`} href="/email-templates" onClick={(e) => { e.preventDefault(); history.push("/email-templates"); }}>
                                                <span className="menu-label">Templates E-mail</span>
                                            </a>
                                        </li>
                                        <li className="menu-item">
                                            <a className={`menu-link ${history.location.pathname === '/campaign-landing-pages' ? 'active' : ''}`} href="/campaign-landing-pages" onClick={(e) => { e.preventDefault(); history.push("/campaign-landing-pages"); }}>
                                                <span className="menu-label">Landing Pages</span>
                                            </a>
                                        </li>
                                        <li className="menu-item">
                                            <a className={`menu-link ${history.location.pathname === '/campaign-leads' ? 'active' : ''}`} href="/campaign-leads" onClick={(e) => { e.preventDefault(); history.push("/campaign-leads"); }}>
                                                <span className="menu-label">Leads</span>
                                            </a>
                                        </li>
                                        <li className="menu-item">
                                            <a className={`menu-link ${history.location.pathname === '/whatsapp-status' ? 'active' : ''}`} href="/whatsapp-status" onClick={(e) => { e.preventDefault(); history.push("/whatsapp-status"); }}>
                                                <span className="menu-label">Status WhatsApp</span>
                                            </a>
                                        </li>
                                    </ul>
                                </li>

                                {/* Integrações */}
                                <li className={`menu-item menu-arrow ${openMenus.integracoes || history.location.pathname.startsWith('/integrations') ? 'show' : ''}`}>
                                    <a className={`menu-link ${history.location.pathname.startsWith('/integrations') ? 'active' : ''}`} href="javascript:void(0);" onClick={() => handleMenuClick('integracoes')}>
                                        <i className="fi fi-rr-link"></i>
                                        <span className="menu-label">Integrações</span>
                                    </a>
                                    <ul className="menu-inner" style={{ display: (openMenus.integracoes || history.location.pathname.startsWith('/integrations')) ? 'block' : 'none' }}>
                                        <li className="menu-item">
                                            <a className={`menu-link ${history.location.pathname === '/integrations/wordpress' ? 'active' : ''}`} href="/integrations/wordpress" onClick={(e) => { e.preventDefault(); history.push("/integrations/wordpress"); }}>
                                                <span className="menu-label">WordPress</span>
                                            </a>
                                        </li>
                                        <li className="menu-item">
                                            <a className={`menu-link ${history.location.pathname === '/integrations/dzapy-chat' ? 'active' : ''}`} href="/integrations/dzapy-chat" onClick={(e) => { e.preventDefault(); history.push("/integrations/dzapy-chat"); }}>
                                                <span className="menu-label">Dzapy Chat</span>
                                            </a>
                                        </li>
                                        <li className="menu-item">
                                            <a className={`menu-link ${history.location.pathname === '/integrations/api-dzapy' ? 'active' : ''}`} href="/integrations/api-dzapy" onClick={(e) => { e.preventDefault(); history.push("/integrations/api-dzapy"); }}>
                                                <span className="menu-label">API Dzapy</span>
                                            </a>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </nav>
                        <div className="app-footer">
                            <a href="#" className="btn btn-outline-light waves-effect btn-shadow btn-app-nav w-100">
                                <i className="fi fi-rs-interrogation text-primary"></i>
                                <span className="nav-text">Ajuda e Suporte (v11.34)</span>
                            </a>
                        </div>
                    </aside>

                    {/* Main Content */}
                    <main className="app-wrapper">
                        {children}
                    </main>

                    {/* Notifications Popover */}
                    <NotificationsPopOver
                        open={notificationsPopoverOpen}
                        anchorEl={notificationsAnchor}
                        onClose={handleNotificationsClose}
                    />
                </div>
            </div>

            {/* User Modal - Renderizado FORA do wrapper principal para evitar conflito de Z-index */}
            <UserModal
                open={openUserModal}
                onClose={() => setOpenUserModal(false)}
                userId={user?.id}
            />
        </React.Fragment>
    );
};

export default GxonLayout;
